<template>
    <div>
        <div class="cuadro">
        <img v-if="tipo === 'asiento' && disponible === 1 && seleccionado === false && pantalla === false" src="/img/venta/disponible.png" class="centrado" @click="selectAsiento()" style="cursor: pointer;">
        <img v-if="tipo === 'asiento' && disponible === 1 && seleccionado === false && pantalla === true" src="/img/venta/asientotv.png" class="centrado" @click="selectAsiento()" style="cursor: pointer;">
        <img v-if="tipo === 'asiento' && disponible === 0 && seleccionado === false && ocupado != '4'" src="/img/venta/ocupado.png" class="centrado">
        <img v-if="tipo === 'asiento' && seleccionado === true" src="/img/venta/seleccionado.png" class="centrado">
        <img v-if="tipo === 'asiento' && ocupado === '4'" src="/img/venta/bloqueado.png" class="centrado">
        <div class="text-center">
            <span class="numeroAsiento" v-if="numero && disponible === 0 && seleccionado === false && ocupado != '4'">{{numero}}|{{categoria_letra}}</span>
            <span class="numeroAsiento" v-if="numero && disponible === 1 && seleccionado === false" @click="selectAsiento()" style="cursor: pointer;">{{numero}}|{{categoria_letra}}</span>
            <span class="numeroAsiento" v-if="numero && disponible === 0 && seleccionado === false && ocupado === '4'">{{numero}}|{{categoria_letra}}</span>
            <span class="numeroAsiento" v-if="numero && seleccionado === true" style="color: white;">{{numero}}|{{categoria_letra}}</span>
        </div>
        <span class="cantidad" v-if="cantidadBoletos > 0">{{ cantidadBoletos }} 
            <span v-if="cantidadBoletos === 1">Boleto</span> 
            <span v-if="cantidadBoletos > 1">Boletos</span>
        </span>

        <img v-if="banoTipo === 'Mixto'" src="/img/layout/mixto.png" class="centrado">
        <img v-if="banoTipo === 'Hombres'" src="/img/layout/hombres.png" class="centrado">
        <img v-if="banoTipo === 'Mujeres'" src="/img/layout/mujeres.png" class="centrado">

        <img v-if="tipo === 'escalera'" src="/img/layout/escalera.png" class="centrado">
        <img v-if="tipo === 'operador'" src="/img/layout/operador.png" class="centrado">
        <img v-if="tipo === 'television'" src="/img/layout/television.png" class="centrado">
        <img v-if="tipo === 'cafeteria'" src="/img/layout/cafeteria.png" class="centrado">
        </div>
    </div>
</template>
<script>
import formMixin from "@/mixins/form-mixin";

export default {
mixins: [formMixin],
props: {
    value: { required: false },
    cambiaAsiento: { required: false },
    asientoACopiar: { required: false },
    terminaCambioAsiento: { required: false },
    terminaCambioAsientoTabla: { required: false },
    canje: { required: false },
    boletos: { required: false },
    boletos_limbo: { required: false },
    id: { required: false },
},
data() {
    return {
    auth: {
        type: "autorizar",
        usuario: null,
        password: null,
        permiso: null,
    },
    autorizacionBloqueo: false,
    showBloqueoAsientoModal: false,
    showMotiveModal: false,
    motive: {},
    permiso: {},
    seleccion: {},
    tipo: null,
    disponible: null,
    seleccionado: false,
    ocupado: '',
    numero: null,
    categoria: null,
    categoria_letra: null,
    pantalla: false,
    precio_taquilla: null,
    precio_en_linea: null,
    motivo_bloqueo: null,
    bano: null,
    banoTipo: null,
    banos: [
        { nombre: 'Mixto'},
        { nombre: 'Hombres'},
        { nombre: 'Mujeres'}
    ],
    cantidadBoletos: null
    };
},
created() {
    if(!!this.value){
    if(this.value.tipo){
        this.tipo = this.value.tipo;
    }
    if(this.value.tipo === 'asiento'){
        this.disponible = this.value.disponible;
        this.numero = this.value.numero;
        const categoriaNombre = this.value.categoria.nombre;
        this.categoria = this.value.categoria;
        this.categoria_letra = categoriaNombre.charAt(0);
        this.pantalla = this.value.pantalla;
        this.ocupado = this.value.motivo_ocupado;
        this.motivo_bloqueo = this.value.motivo_bloqueo;
        this.precio_taquilla = this.value.precio_taquilla;
        this.precio_en_linea = this.value.precio_en_linea;
        this.cantidadBoletos = this.value.cantidadBoletos;
    }
    this.banoTipo = this.value.bano;
    if(this.value.bano === 'Mixto'){
        this.bano = this.banos[0];
    }
    if(this.value.bano === 'Hombres'){
        this.bano = this.banos[1];
    }
    if(this.value.bano === 'Mujeres'){
        this.bano = this.banos[2];
    }
    }
},
computed: {
    
},
methods: {
    updateItem(){
        const val = {
            'cantidadBoletos': this.cantidadBoletos,  
            'disponible': this.disponible, 
            'ocupado': this.ocupado, 
            'seleccionado': this.seleccionado, 
            'numero': this.numero, 
            'categoria': this.categoria, 
            'categoria_letra': this.categoria_letra,
            'tipo': this.tipo,
            'motivo_bloqueo': this.motivo_bloqueo,
            'motivo_ocupado': this.motivo_ocupado,
            'precio_en_linea': this.precio_en_linea,
            'precio_taquilla': this.precio_taquilla,
            'id': this.id,
        };
        this.$emit('input', val);
    },

    async selectAsiento(){
        if(this.cambiaAsiento){
            this.addAsiento();
        }else{
            this.$notify({
            type: "danger",
            message: "¡Es necesario seleccionar un asiento del layout de corrida origen!",
            duration: -1
            });
        }
    },

    async addAsiento(){
      this.canje.asiento_destino = Number(this.numero);
      try {
      await this.$store.dispatch("corridas/canjearAsiento", this.canje);
      this.$notify({
          type: "success",
          message: "Asiento cambiado satisfactoriamente.",
          duration: -1
      });
      this.disponible = 0;
      //this.boletos = this.asientoACopiar.boletos;
      this.cantidadBoletos = this.asientoACopiar.cantidadBoletos;
      this.updateItem();
      if(this.boletos != null){ this.terminaCambioAsiento() };
      if(this.boletos_limbo != null){ this.terminaCambioAsientoTabla() };
      } catch (error) {
          this.$notify({
          type: "danger",
          message: error.response.data.errors[0].detail,
          duration: -1
          });
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
      }
    },
},
watch: {
    value(newValue) {
    if(!!newValue){
        //this.tipo = newValue.tipo;
    } 
    },
},
};
</script>
<style>
    .cuadro{
        background-color:#fff !important;
        border-style: none !important;
        border-color: #989295 !important;
        height: 65px;
        width: 65px;
    }
    .cuadro:hover{
        background-color: #fff !important;
        cursor: auto;
    }
    .centrado{
        position: relative;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        height: 55px;
        width: 55px;
    }
    .numeroAsiento{
      position:relative;
      bottom: 35px !important;
      font-size: 11px !important;
      right: -3px !important;
    }
    .cantidad{
        position:relative;
        bottom: 29px !important;
        left: 10px !important;
        font-size: 12px !important;
    }
</style>
<style lang="scss">
    .argon-error {
    position: relative;
    bottom: 25px !important;
    color: #fb6340;
    }

</style>

